
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.83 4.82997L12.7 2.69997C12.08 2.07997 11 2.51997 11 3.40997V4.06997C7.06 4.55997 4 7.91997 4 12C4 15.64 6.43 18.71 9.77 19.68C10.39 19.86 11 19.36 11 18.72V18.69C11 18.26 10.73 17.87 10.32 17.75C7.82 17.03 6 14.73 6 12C6 9.02997 8.16 6.56997 11 6.08997V7.61997C11 8.50997 12.07 8.94997 12.7 8.32997L14.83 6.24997C15.23 5.86997 15.23 5.22997 14.83 4.82997ZM19.67 9.75997C19.51 9.20997 19.29 8.67997 19.01 8.16997C18.7 7.59997 17.91 7.50997 17.45 7.96997L17.44 7.97997C17.13 8.28997 17.06 8.75997 17.27 9.13997C17.47 9.50997 17.63 9.89997 17.75 10.3C17.87 10.72 18.26 11 18.69 11H18.71C19.36 11 19.86 10.38 19.67 9.75997ZM13 18.68V18.7C13 19.35 13.62 19.84 14.24 19.66C14.79 19.5 15.32 19.28 15.83 19C16.4 18.69 16.49 17.9 16.03 17.44L16.01 17.42C15.7 17.11 15.23 17.04 14.85 17.25C14.48 17.46 14.09 17.62 13.69 17.74C13.28 17.86 13 18.25 13 18.68ZM17.44 16.03C17.9 16.49 18.69 16.4 19 15.83C19.28 15.32 19.5 14.79 19.67 14.24C19.85 13.62 19.36 13 18.71 13H18.69C18.25 13 17.87 13.28 17.75 13.7C17.63 14.1 17.47 14.49 17.27 14.87C17.06 15.25 17.14 15.73 17.44 16.03Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-rotate-right`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRotateRight

    ```js
    <b-new-b-icon-rotate-right />
    ```
</docs>


